module.exports = __webpack_public_path__ + "static/media/heroExploreButtonArrow.71178458.svg";